import React from 'react';
import { Star } from 'lucide-react';

const StarRating = ({ 
  rating = 0, 
  size = 'md', 
  showValue = false, 
  showCount = false, 
  count = 0,
  interactive = false,
  onChange,
  className = ''
}) => {
  const sizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
    xl: 'w-6 h-6',
  };

  const textSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg',
  };

  const handleClick = (starValue) => {
    if (interactive && onChange) {
      onChange(starValue);
    }
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <div className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => handleClick(star)}
            className={`${interactive ? 'cursor-pointer hover:scale-110 transition-transform' : 'cursor-default'}`}
            disabled={!interactive}
          >
            <Star
              className={`
                ${sizes[size]}
                ${star <= Math.round(rating) ? 'fill-amber-400 text-amber-400' : 'text-gray-300'}
              `}
            />
          </button>
        ))}
      </div>
      {showValue && (
        <span className={`font-medium text-gray-900 ${textSizes[size]}`}>
          {rating.toFixed(1)}
        </span>
      )}
      {showCount && (
        <span className={`text-gray-500 ${textSizes[size]}`}>
          ({count} {count === 1 ? 'review' : 'reviews'})
        </span>
      )}
    </div>
  );
};

export default StarRating;
